import React, { useEffect, useState } from "react";
import Div from "@jumbo/shared/Div/Div";
import { Button, TextareaAutosize,CircularProgress } from "@mui/material";


const NotesTab = ({
  id,
  onSubmit,
  note,
  setNote,
  handleClose,
  previousNote,
  loading
}) => {
  // Initially, show the buttons if the note is different from the previousNote
  const [showSaveBtn, setShowSaveBtn] = useState(false);

  // Whenever the note changes, update the showSaveBtn state
  useEffect(() => {
    setShowSaveBtn(note !== previousNote);
  }, [note]);

  return (
    <Div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(note);
          handleClose();
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              {showSaveBtn && (
                <div className="form-action-area container mb-0 px-0">
                  {loading ? <CircularProgress /> :<Button
                    type="submit"
                    variant="contained"
                    className="btn-theme"
                    onClick={(e) => {
                      e.preventDefault();
                      onSubmit(note);
                      handleClose();
                    }}
                  >
                    Submit
                  </Button>}
                </div>
              )}
              <div className="form-group">
                <label htmlFor="message" className="mb-2 fs-6">
                  Add Note
                </label>
                <Div
                  sx={{
                    position: "relative",
                    "& .pencil-icon-btn": {
                      position: "absolute",
                      bottom: "15px",
                      right: "17px",
                      p: 0,
                    },
                    "& .pencil-icon": {
                      fontSize: "25px",
                    },
                    "& .form-control": {
                      pr: "22px",
                    },
                  }}
                >
                  <TextareaAutosize
                    maxRows={4}
                    minRows={4}
                    aria-label="maximum height"
                    placeholder="Add Message"
                    className="form-control shadow-none"
                    id="message"
                    name="message"
                    label="message"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  />
                </Div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Div>
  );
};

export default NotesTab;
